import "../../../src/App.css";
import State from "../../components/State/State";
import AddState from "../../components/AddState/AddState";
// import Navbar from "../../components/Navbar/navbar";
// import Sidebar from "../../components/Sidebar/Sidebar";
import StateList from "../../components/StateList/StateList";
import React, { useState, useEffect } from "react";
import axios from "axios";
import MasterTopButtons from "../../components/MasterTopButtons/MasterTopButtons";
import PaginationLink from "../../components/Pagination/Pagination";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import FilterStateData from "../../components/FilterStateData/FilterStateData";

function StateMaster() {
  const [stateDetailResponse, setStateDetailResponse] = useState(null);
  const [openProfile, setOpenProfile] = useState(false);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const [selectedStateId, setSelectedStateId] = useState(); 
  const [filterStateData,setFilterStateData] = useState(false);
  const title = "Add State";
  const heading = "State List";
  const baseAPI = process.env.REACT_APP_API_URL;

  function tokenStorage(){
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETState?stateID=0&countryID=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          //console.log(response.data.data);
          setStateDetailResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }


  useEffect(() => {
    tokenStorage();
  }, []);

  //console.log(stateDetailResponse);

  const GetId = (param) => {   
    setSelectedStateId(param);
    
  };


  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  State Master| <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt; Master</span>
                </h1>
              </div>
              <div style={{ width: "8rem" }}>
                <select className="form-control" name="country">
                  <option value="0">INDIA </option>
                  <option value="1">DUBAI </option>
                </select>
              </div>
            </div>
            <div>
              <Wrapper className="ViewLeadDetails">
                <MasterTopButtons
                  title={title}
                  heading={heading}
                  setOpenAddProfile={setOpenAddProfile}
                  openAddProfile={openAddProfile}
                  setOpenProfile = {setOpenProfile}
                  setFilterCityData = {setFilterStateData}
                  filterCityData = {filterStateData}
                />
                {openAddProfile ? <AddState tokenStorage = {tokenStorage} openAddProfile = {openAddProfile} setOpenAddProfile = {setOpenAddProfile} setFilterStateData = {setFilterStateData}/> : null}
                {openProfile ? <State tokenStorage = {tokenStorage} openProfile = {openProfile} setOpenProfile = {setOpenProfile} selectedStateId={selectedStateId} /> : null}
                {filterStateData? <FilterStateData tokenStorage={tokenStorage} setStateDetailResponse = {setStateDetailResponse} stateDetailResponse = {stateDetailResponse} setFilterStateData = {setFilterStateData} filterStateData = {filterStateData}/> : null}
                <StateList
                  stateDetailResponse={stateDetailResponse}
                  setOpenProfile={setOpenProfile}
                  openProfile={openProfile}
                  GetId={(param) => GetId(param)}                  
                  setOpenAddProfile = {setOpenAddProfile}
                  setFilterStateData = {setFilterStateData}
                />
                {/* <PaginationLink /> */}
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StateMaster;
